const getters = {
  loginUserInfo: (state) => state.user.loginUserInfo, // 用户信息
  chatList: (state) => state.user.chatList, // 聊天列表
  corresponding_user_information: (state) => state.user.corresponding_user_information, // 对应用户的信息
  chatListHistory: (state) => state.user.chatListHistory, // 聊天的历史记录
  oldChatKey: (state) => state.user.oldChatKey, // 旧聊天key
  newChatKey: (state) => state.user.newChatKey, // 新聊天key
  searchChatList20: (state) => state.user.searchChatList20, // 人气推荐前20
  isVersionUpdate: (state) => state.user.isVersionUpdate, // 人气推荐前20
  destruction:(state) => state.data.destruction, // 人气推荐前20
};
export default getters;
